import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators } from '@angular/forms';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';

import { Dropdown } from './../../models/editors/dropdown.model';
import { BookingItem, BookingOffer } from './../../models/bookings/bookings.model';
import { Textarea } from './../../models/editors/textarea.model';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { requiredBoundFieldValidator } from './../../shared/validators/requiredBoundField.validator';
import { Contained } from './../../models/editors/contained.model';
import { Switch } from './../../models/editors/switch.model';

@Component({
  selector: 'swb-booking-item-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class BookingItemDetailComponent extends FormDetailBase<BookingItem> implements OnInit, OnDestroy {

  private _booking_offer_id: number;

  public url = 'booking-items';

  protected _redirect = './bookings';

  public entity = new BookingItem({});
  public offers: Array<BookingOffer> = [];

  public get fieldsConfig(): Array<any> {
    return [
      new Dropdown({
        key: 'booking_offer_id',
        label: 'Rezervační nabídka',
        options: this._formService.getDropdownValues('title', this.offers),
        value: this._booking_offer_id ? this._booking_offer_id : this.entity.booking_offer_id,
        defaultValue: this.offers[0] ? this.offers[0].id : null
      }),
      new Textbox({
        key: 'title',
        label: 'Název položky',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'description',
        label: 'Popisek',
        isMultilang: true,
        wysiwyg: true
      }),
      new Textbox({
        key: 'default_price',
        type: 'number',
        label: 'Cena za den (Kč)',
        validators: [Validators.required]
      }),
      new Switch({
        key: 'price_per_month',
        defaultValue: false,
        label: 'Cena se liší dle měsíce'
      }),
      new Textbox({
        key: 'price_month_01',
        type: 'number',
        label: 'Leden - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_02',
        type: 'number',
        label: 'Únor - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_03',
        type: 'number',
        label: 'Březen - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_04',
        type: 'number',
        label: 'Duben - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_05',
        type: 'number',
        label: 'Květen - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_06',
        type: 'number',
        label: 'Červen - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_07',
        type: 'number',
        label: 'Červenec - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_08',
        type: 'number',
        label: 'Srpen - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_09',
        type: 'number',
        label: 'Září - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_10',
        type: 'number',
        label: 'Říjen - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_11',
        type: 'number',
        label: 'Listopad - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'price_month_12',
        type: 'number',
        label: 'Prosinec - cena (Kč)',
        validators: [requiredBoundFieldValidator('price_per_month')],
        boundTo: 'price_per_month'
      }),
      new Textbox({
        key: 'amount',
        type: 'number',
        label: 'Počet položek k dispozici',
        validators: [Validators.required],
        defaultValue: 1
      }),
      new Switch({
        key: 'available',
        defaultValue: true,
        label: 'Je momentálně k dispozici'
      }),
      new Contained({
        key: 'file_id',
        label: 'Náhledový obrázek',
        imgOnly: true,
        upload: true,
        entity: this.entity.file
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {


    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (typeof this._route.snapshot.params['booking_offer_id'] !== 'undefined') {
      this._booking_offer_id = parseInt(this._route.snapshot.params['booking_offer_id'], 10);
    }

    this._getBookingOffersList();

  }

  protected _setupForm(): void {
    this.form = this._formService.toFormGroup(this.fieldsConfig.slice(), this.entity);
    this.formEditors = this._formService.toTemplateInput(this.fieldsConfig.slice(), this.entity);
    this.isInitialized = true;

  }

  public ngOnDestroy(): void {
    // TODO: do something
  }

  private _getBookingOffersList() {
    this._apiService.get('booking-offers/list')
      .subscribe(
        (response: any) => {
          this.offers = { ...response }.data;
          this._getEntity();
        },
        (error) => console.error(error)
      );
  }

}
